import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Container
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import AddEquipInventoryComp from "../../../components/Inventory/AddEquipInventoryComp";

const UpdateInventory = (props) => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Equipments")}
            breadcrumbItem2={props.t("Update Inventory")}
          />
          <AddEquipInventoryComp />
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(UpdateInventory))
);
